export default "__VITE_ASSET__DzFOTlMF__"